import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };


const getMedications = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/medications/list',
    headers,
    successCallback,
    errorCallback);
};

const requestRefill = (data, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/medications/refill',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback);
};

export default {
  getMedications,
  requestRefill,
};


// WEBPACK FOOTER //
// ./src/apis/medications.js